module.exports = __webpack_public_path__ + "img/setup-test-step-1-mobile.5ec679c9.png";